const RichmarkerLibrary = require('js-rich-marker');

// The goal of this file is to avoid calls to google api from unit tests
const Map = (el, options) => {
  // eslint-disable-next-line no-undef
  return new google.maps.Map(el, options);
}
const LatLng = (lat, lng) => {
  // eslint-disable-next-line no-undef
  return new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
}

const LatLngBounds = (
  ...data
) => {
  // eslint-disable-next-line no-undef
  return new google.maps.LatLngBounds(
    ...data
  );
}

const OverlayView = () => {
  // eslint-disable-next-line no-undef
  return new google.maps.OverlayView();
}

const Point = (...data) => {
  // eslint-disable-next-line no-undef
  return new google.maps.Point(...data);
}

// eslint-disable-next-line no-undef
const event = google.maps.event;
// eslint-disable-next-line no-undef
const ControlPosition = google.maps.ControlPosition;

const RichMarkerPosition = RichmarkerLibrary.RichMarkerPosition;

// custom functions

const getBounds = (bounds) => {
  const southWestCoords = LatLng(bounds.southWest.lat, bounds.southWest.lng);
  const northEastCoords = LatLng(bounds.northEast.lat, bounds.northEast.lng);
  return LatLngBounds(southWestCoords, northEastCoords);
}

const richmarker = (marker) => {
  return new RichmarkerLibrary.RichMarker(marker);
}

export {
  Map,
  LatLng,
  LatLngBounds,
  Point,
  OverlayView,
  event,
  ControlPosition,
  RichMarkerPosition,
  getBounds,
  RichmarkerLibrary,
  richmarker
}



// WEBPACK FOOTER //
// ./demo/components/map-component/src/helpers/googleHelper.js